module.exports = __webpack_public_path__ + "img/antes_despues_45.2ab34ccc.png";